import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { AppContext, ApiService, AuthService, UserService, Register } from './../shared';
import { LoginService } from './login.service';

@Component({
  selector: 'login',
  template: require('./login.component.html'),
  styles: [require('./login.component.scss')],
  providers: [LoginService]
})

export class LoginComponent implements OnInit {
  errorMessage: string;
  displayLogin: boolean = true;

  displayVerificationInput: boolean = false;
  displayResult: boolean = false;

  displayForgotPassword: boolean = false;
  forgotError: string = '';

  displayForgotPasswordMessage: boolean = false;

  verificationStatus: string = '';
  verificationCode: string = '';
  submitted: boolean = false;

  loginForm = new FormGroup({
    email: new FormControl(),
    password: new FormControl()
  });

  forgotForm = new FormGroup({
    email: new FormControl()
  });

  confirmForm = new FormGroup({
    code: new FormControl(),
    password: new FormControl()
  });

  header: string = 'Login';

  @Input()
  cognitoUser: any;

  constructor(private service: LoginService, private app: AppContext, private api: ApiService, private authService: AuthService, private userService: UserService, private formBuilder: FormBuilder, private router: Router) {
    // Do stuff
  }

  ngOnInit() {
    this.submitted = false;

    this.loginForm = this.formBuilder.group({
      email: ['', this.service.validateEmail],
      password: ['', Validators.compose([this.service.validatePassword, Validators.minLength(1)])]
    });

    this.forgotForm = this.formBuilder.group({
      email: ['', this.service.validateEmail]
    });

    this.confirmForm = this.formBuilder.group({
      code: '',
      password: ['', Validators.compose([this.service.validatePassword, Validators.minLength(8)])]
    });
    // changed password length from 8 for migration process
  }

  login() {
    if (this.loginForm.valid) {
      this.service.login(this.loginForm.controls['email'].value, this.loginForm.controls['password'].value)
        .then(result => {
          this.close();
          let url = this.router.url;
          this.router.navigate(['/']).then(navigateResult => this.router.navigateByUrl(url));
        })
        .catch(err => this.handleError(err));
    }
    this.submitted = true;

    this.app.closeSearch();

    // ****
    //window.location.reload()
    var appStatus = this.app;
    if (this.app.accountType == 'Professional') {
      sessionStorage.setItem('schedules-week', '8');
      sessionStorage.setItem('schedules-origin-nearby', 'ture');
      sessionStorage.setItem('schedules-destination-nearby', 'true');
    } else if (this.app.accountType == 'Premium') {
      sessionStorage.setItem('schedules-week', '6');
      sessionStorage.setItem('schedules-origin-nearby', 'ture');
      sessionStorage.setItem('schedules-destination-nearby', 'true');
    } else if (this.app.accountType == 'Basic') {
      sessionStorage.setItem('schedules-week', '4');
      sessionStorage.setItem('schedules-origin-nearby', 'false');
      sessionStorage.setItem('schedules-destination-nearby', 'false');
    }
    // ****
  }

  resend() {
    this.displayResult = false;
    this.service.resendLoaderOn = true;
    this.service.resendVerificationCode(this.loginForm.controls['email'].value).then((result: boolean) => {
      this.verificationEmailResent(result);
    }).catch(err => {
      this.errorMessage = err;
      this.service.resendLoaderOn = false;
    });
  }

  verificationEmailResent(result: boolean) {
    this.displayVerificationInput = false;
    this.displayResult = true;
    this.service.resendLoaderOn = false;

    this.verificationStatus = result ? 'Your verification email has been resent. Please click the link in the email to confirm.' : 'There was a problem when we tried to send you a new email. Please try again';
  }

  openForgot() {
    if (this.forgotForm.controls['email'].value === '') {
      this.forgotForm.setValue({ email: this.loginForm.controls['email'].value });
    }

    this.displayForgotPassword = true;
    this.displayLogin = false;
    this.header = 'Forgot Password';
    this.displayVerificationInput = false;
  }

  closeForgot() {
    this.displayForgotPassword = false;
    this.displayLogin = true;
    this.header = 'Login';
  }

  forgot() {
    let email = this.forgotForm.controls['email'].value;

    this.service.forgotPassword(email).then((result) => {
      this.app.setEmail(email);
      this.displayForgotPassword = false;
      this.displayForgotPasswordMessage = true;
    }).catch(err => {
      if (err.message === 'Username/client id combination not found.') {
        // this.forgotError = 'Unrecognized Email';
        // pretend the email was sent out
        this.displayForgotPassword = false;
        this.displayForgotPasswordMessage = true;
      } else if (err.message == 'Attempt limit exceeded, please try after some time.') {
        this.forgotError = 'Too many attempts. Please Try Again Later';
      } else if (err.Message = 'Cannot reset password for the user as there is no registered/verified email or phone_number') {
        this.forgotError = 'You must confirm your account first. Please check your email for a confirmation link. (It may take several minutes to reach your inbox.)';
        this.authService.resendVerificationEmail(email);
        //this.resend();
      } else {
        this.forgotError = 'Please Try Again Later';
      }
    });
  }

  private handleError(error: string) {
    if (error === 'User is not confirmed.') {
      this.displayLogin = false;
      this.displayVerificationInput = true;
    } else if (error === 'User does not exist.') {
      error = 'Incorrect username or password.';
    }
    this.errorMessage = error;
  }

  close() {
    this.app.login = false;
    this.header = 'Login';
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/login/login.component.ts